import React, { useState } from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaUser, FaIdCard, FaMobile, FaComment } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    itsNumber: '',
    email: '',
    mobileNumber: '',
    comment: ''
  });
  const [selectedCountryCode, setSelectedCountryCode] = useState('+91'); // India by default


  // Country codes data
  const countryCodes = [
    { code: '+91', country: 'India', flag: '🇮🇳' },
    { code: '+1', country: 'USA/Canada', flag: '🇺🇸' },
    { code: '+44', country: 'UK', flag: '🇬🇧' },
    { code: '+61', country: 'Australia', flag: '🇦🇺' },
    { code: '+971', country: 'UAE', flag: '🇦🇪' },
    { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦' },
    { code: '+974', country: 'Qatar', flag: '🇶🇦' },
    { code: '+973', country: 'Bahrain', flag: '🇧🇭' },
    { code: '+968', country: 'Oman', flag: '🇴🇲' },
    { code: '+965', country: 'Kuwait', flag: '🇰🇼' },
    { code: '+20', country: 'Egypt', flag: '🇪🇬' },
    { code: '+27', country: 'South Africa', flag: '🇿🇦' },
    { code: '+86', country: 'China', flag: '🇨🇳' },
    { code: '+81', country: 'Japan', flag: '🇯🇵' },
    { code: '+82', country: 'South Korea', flag: '🇰🇷' },
    { code: '+65', country: 'Singapore', flag: '🇸🇬' },
    { code: '+60', country: 'Malaysia', flag: '🇲🇾' },
    { code: '+66', country: 'Thailand', flag: '🇹🇭' },
    { code: '+84', country: 'Vietnam', flag: '🇻🇳' },
    { code: '+62', country: 'Indonesia', flag: '🇮🇩' }
  ];
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Special handling for ITS Number field
    if (name === 'itsNumber') {
      // Only allow digits and limit to 8 characters
      const numericValue = value.replace(/\D/g, '').slice(0, 8);
      setFormData(prev => ({
        ...prev,
        [name]: numericValue
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate ITS Number length
    if (formData.itsNumber.length !== 8) {
      alert('ITS Number must be exactly 8 digits');
      return;
    }
    
    if (!recaptchaToken) {
      alert('Please complete the reCAPTCHA verification');
      return;
    }

    setIsSubmitting(true);
    
    try {
      // Simulate form submission
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      setSubmitStatus('success');
      setFormData({
        fullName: '',
        itsNumber: '',
        email: '',
        mobileNumber: '',
        comment: ''
      });
      setRecaptchaToken('');
      
      // Reset status after 5 seconds
      setTimeout(() => setSubmitStatus(null), 5000);
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const handleCountryCodeChange = (e) => {
    setSelectedCountryCode(e.target.value);
  };

  return (
    <div style={{ 
      background: 'linear-gradient(to right, #91eae4, #86a8e7, #7f7fd5)',
      minHeight: '100vh',
      fontFamily: '"Quicksand", sans-serif'
    }}>
      {/* Header Navigation */}
      <Header />

      {/* Header Section */}
      <div className="container mb-5" style={{ paddingTop: '2rem' }}>
        <div className="row align-items-center">
          <div className="col-12 text-center">
            <h1 className="display-6 fw-bold text-white mb-2">Contact Us</h1>
            <p className="text-white-50 mb-0" style={{ fontSize: '1.1rem', maxWidth: '600px', margin: '0 auto' }}>
              Get in touch with us. We'd love to hear from you and assist with your inquiries.
            </p>
          </div>
        </div>
      </div>

      {/* Contact Form and Map Section */}
      <div className="container mb-5">
        <div className="row">
          {/* Contact Form */}
          <div className="col-lg-6 mb-4">
            <div style={{
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '20px',
              padding: '2rem',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
            }}>
              <h2 style={{
                color: '#1e40af',
                fontWeight: '700',
                fontSize: '2rem',
                marginBottom: '1.5rem',
                textAlign: 'center'
              }}>Send us a Message</h2>

              {submitStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Thank you! Your message has been sent successfully. We'll get back to you soon.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="alert alert-danger" role="alert">
                  Sorry, there was an error sending your message. Please try again.
                </div>
              )}

              <form onSubmit={handleSubmit}>
                {/* Full Name */}
                <div className="mb-3">
                  <label className="form-label text-white fw-semibold">
                    <FaUser style={{ marginRight: '8px' }} />
                    Full Name *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                    style={{
                      background: 'rgba(255, 255, 255, 0.9)',
                      border: '1px solid rgba(255, 255, 255, 0.3)',
                      borderRadius: '8px',
                      padding: '12px 16px'
                    }}
                  />
                </div>

                                 {/* ITS Number */}
                 <div className="mb-3">
                   <label className="form-label text-white fw-semibold">
                     <FaIdCard style={{ marginRight: '8px' }} />
                     ITS Number * (8 digits only)
                   </label>
                   <input
                     type="text"
                     className="form-control"
                     name="itsNumber"
                     value={formData.itsNumber}
                     onChange={handleInputChange}
                     required
                     maxLength="8"
                     pattern="[0-9]{8}"
                     placeholder="Enter 8-digit ITS Number"
                     style={{
                       background: 'rgba(255, 255, 255, 0.9)',
                       border: '1px solid rgba(255, 255, 255, 0.3)',
                       borderRadius: '8px',
                       padding: '12px 16px'
                     }}
                   />
                   {formData.itsNumber.length > 0 && formData.itsNumber.length !== 8 && (
                     <small className="text-warning" style={{ fontSize: '0.875rem', marginTop: '0.25rem', display: 'block' }}>
                       ITS Number must be exactly 8 digits
                     </small>
                   )}
                 </div>

                {/* Email */}
                <div className="mb-3">
                  <label className="form-label text-white fw-semibold">
                    <FaEnvelope style={{ marginRight: '8px' }} />
                    Email ID *
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    style={{
                      background: 'rgba(255, 255, 255, 0.9)',
                      border: '1px solid rgba(255, 255, 255, 0.3)',
                      borderRadius: '8px',
                      padding: '12px 16px'
                    }}
                  />
                </div>

                                 {/* Mobile Number */}
                 <div className="mb-3">
                   <label className="form-label text-white fw-semibold">
                     <FaMobile style={{ marginRight: '8px' }} />
                     Mobile Number *
                   </label>
                   <div style={{ display: 'flex', gap: '8px' }}>
                     {/* Country Code Dropdown */}
                     <select
                       value={selectedCountryCode}
                       onChange={handleCountryCodeChange}
                       style={{
                         background: 'rgba(255, 255, 255, 0.9)',
                         border: '1px solid rgba(255, 255, 255, 0.3)',
                         borderRadius: '8px',
                         padding: '12px 8px',
                         minWidth: '120px',
                         fontSize: '0.9rem',
                         color: '#1f2937'
                       }}
                     >
                       {countryCodes.map((country) => (
                         <option key={country.code} value={country.code}>
                           {country.flag} {country.code}
                         </option>
                       ))}
                     </select>
                     {/* Mobile Number Input */}
                     <input
                       type="tel"
                       className="form-control"
                       name="mobileNumber"
                       value={formData.mobileNumber}
                       onChange={handleInputChange}
                       required
                       placeholder="Enter mobile number"
                       style={{
                         background: 'rgba(255, 255, 255, 0.9)',
                         border: '1px solid rgba(255, 255, 255, 0.3)',
                         borderRadius: '8px',
                         padding: '12px 16px',
                         flex: 1
                       }}
                     />
                   </div>
                 </div>

                {/* Comment */}
                <div className="mb-4">
                  <label className="form-label text-white fw-semibold">
                    <FaComment style={{ marginRight: '8px' }} />
                    Comment *
                  </label>
                  <textarea
                    className="form-control"
                    name="comment"
                    value={formData.comment}
                    onChange={handleInputChange}
                    required
                    rows="4"
                    placeholder="How we may assist you?"
                    style={{
                      background: 'rgba(255, 255, 255, 0.9)',
                      border: '1px solid rgba(255, 255, 255, 0.3)',
                      borderRadius: '8px',
                      padding: '12px 16px',
                      resize: 'vertical'
                    }}
                  />
                </div>

                {/* Google reCAPTCHA */}
                <div className="mb-4 d-flex justify-content-center">
                  <div 
                    className="g-recaptcha" 
                    data-sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                    data-callback={handleRecaptchaChange}
                  ></div>
                </div>

                {/* Submit Button */}
                <div className="text-center">
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg"
                    disabled={isSubmitting}
                    style={{
                      background: '#3b82f6',
                      border: 'none',
                      borderRadius: '12px',
                      padding: '12px 32px',
                      fontWeight: '600',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
                    }}
                  >
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* Map and Address */}
          <div className="col-lg-6">
            <div style={{
              background: 'white',
              borderRadius: '20px',
              padding: '2rem',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              height: '100%'
            }}>
              <h2 style={{
                color: '#1e40af',
                fontWeight: '700',
                fontSize: '2rem',
                marginBottom: '1.5rem',
                textAlign: 'center'
              }}>Our Location</h2>

              {/* Address */}
              <div className="mb-4">
                <h4 style={{ color: '#1f2937', fontWeight: '600', marginBottom: '1rem' }}>
                  <FaMapMarkerAlt style={{ marginRight: '8px', color: '#ef4444' }} />
                  Our Address
                </h4>
                <p style={{ 
                  color: '#4b5563', 
                  fontSize: '1.1rem', 
                  lineHeight: '1.6',
                  marginBottom: '0'
                }}>
                  Taj Building, B2, Dr.D. N. Road, Wallace St, Fort,<br />
                  Mumbai, Maharashtra 400001
                </p>
              </div>

              {/* Contact Info */}
              <div className="mb-4">
                <h4 style={{ color: '#1f2937', fontWeight: '600', marginBottom: '1rem' }}>
                  Contact Information
                </h4>
                <div style={{ color: '#4b5563', fontSize: '1.1rem', lineHeight: '1.8' }}>
                                     <p style={{ marginBottom: '0.5rem' }}>
                     <FaPhone style={{ marginRight: '8px', color: '#10b981' }} />
                     <strong>Phone:</strong> +91 22 4921 6552
                   </p>
                                     <p style={{ marginBottom: '0.5rem' }}>
                     <FaEnvelope style={{ marginRight: '8px', color: '#3b82f6' }} />
                     <strong>Email:</strong> info@umooriqtesadiyah.org
                   </p>
                </div>
              </div>

              {/* Google Maps */}
              <div style={{ marginTop: '2rem' }}>
                <h4 style={{ color: '#1f2937', fontWeight: '600', marginBottom: '1rem' }}>
                  Find Us on Google Maps
                </h4>
                <div style={{
                  width: '100%',
                  height: '300px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                }}>
                                     <iframe
                     src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.1234567890123!2d72.833662!3d18.936947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d1e6f4b4b4b4%3A0x1433952043001112854!2sTaj%20Building%2C%20B2%2C%20Dr.D.%20N.%20Road%2C%20Wallace%20St%2C%20Fort%2C%20Mumbai%2C%20Maharashtra%20400001!5e0!3m2!1sen!2sin!4v1234567890123"
                     width="100%"
                     height="100%"
                     style={{ border: 0 }}
                     allowFullScreen=""
                     loading="lazy"
                     referrerPolicy="no-referrer-when-downgrade"
                     title="DBohra Location"
                   ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Spacing */}
      <div style={{ paddingBottom: '3rem' }}></div>
      
      {/* Footer */}
      <Footer />

      {/* Google reCAPTCHA Script */}
      <script src="https://www.google.com/recaptcha/api.js" async defer></script>
    </div>
  );
};

export default ContactUs; 